import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaInformacionDireccionesEditarComponent {
  empresaId = undefined
  indice = undefined
  aceptar = false
  form
  estados
  data = {
    calle: null,
    codigo_postal: null,
    colonia: null,
    idEstado: null,
    estado: null,
    localidad: null,
    municipio: null,
    numero_exterior: null,
    numero_interior: null,
    pais: null,
    timbrado_folio: null,
    timbrado_serie: null,
  }
  onChange = undefined
  onClose = undefined

  constructor (EmpresaInformacionDireccionesDireccion, FanProyectoCatalogosEstadosService, $q) {
    this.EmpresaInformacionDireccionesDireccionService = EmpresaInformacionDireccionesDireccion
    this.FanProyectoCatalogosEstadosService = FanProyectoCatalogosEstadosService
    this.$q = $q
  }

  $onInit () {
    this.promise =
      this.$q.all([
        this.FanProyectoCatalogosEstadosService.get()
        .then(({data}) => (this.estados = data)),
        this.EmpresaInformacionDireccionesDireccionService.get(this.empresaId, this.indice)
        .then((response) => (this.data = response.data)),
      ])

  }

  actualizar (data) {
    this.editando = false
    if (data.exito) {
      this.form.$setPristine()
      this.onChange({$event: {detail: this.data}})
    }
  }

  editandoDireccion () {
    this.data.estado = this.estados.find(item => item.id === this.data.idEstado).descripcion
    this.editando = true
  }
}

module.component('empresaInformacionDireccionesEditar', {
  controller: EmpresaInformacionDireccionesEditarComponent,
  template,
  bindings: {
    empresaId: '<',
    indice: '<',
    onChange: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/informacion/direcciones/editar/component.js